<template>
  <vs-card>
    <div class="vx-row p-5">
      <div class="vx-col w-full px-8">
        <form method="POST" @submit.prevent="save_changes">
          <div class="vx-row">
            <!-- Service Name -->
            <div class="vx-col w-1/2 mb-2">
              <vs-input class="w-full" v-validate="'required|exclude_special_char|min:4'" v-model="form.service_name"
                label="Service Name *" name="service_name" placeholder=" Akhand Paat" data-vv-as="Service Name"
                id="Service Name" />
              <span class="text-danger text-sm" v-show="errors.has('Service Name')">{{ errors.first('Service Name')
                }}</span>
            </div>

            <!-- Platform Fee -->
            <div class="vx-col w-1/2 mb-2">
              <percentage-input>
                <vs-input class="w-full" v-validate="'required|min_value:0|max_value:99'"
                  v-model="form.collection_platform_fee" label="Collection Platform Fee *" name="collection_platform_fee"
                  placeholder="0" data-vv-as="Collection Platform Fee" id="Collection Platform Fee"
                  type="number" min="0" max="99" step="0.01" @input="handlePlatformFeeInput" />
              </percentage-input>
              <span class="text-danger text-sm" v-show="errors.has('Collection Platform Fee')">{{
                errors.first('Collection Platform Fee') }}</span>
            </div>

            <!-- Image -->
            <div class="vx-col w-1/2 cursor-pointer">
              <label class="vs-input--label block">Image *</label>

              <!-- File Input -->
              <input :key="fileKey" type="file" class="border p-2 rounded w-full" ref="files" accept=".jpg, .png, .jpeg"
                @change="handleFileUpload" style="border: 1px solid rgba(0, 0, 0, 0.2)" data-vv-as="Image" />

              <!-- Hidden Input for Validation -->
              <input type="hidden" name="service_image" v-model="form.service_image" v-validate="imagevalidationRule"
                data-vv-as="Image" />

              <!-- Display Validation Error -->
              <span class="text-danger text-sm" v-show="errors.has('service_image')">{{ errors.first('service_image')
                }}</span>

              <!-- Preview Image -->
              <div class="mt-5">
                <div class="relative" v-if="preview_image">
                  <div class="mt-5 overflow-hidden">
                    <img height="150px" width="350px" :src="preview_image" alt="Image Preview" class="object-fit" />
                  </div>
                </div>
              </div>
              <!-- Token Generation Required -->
              <div class="vx-col mb-2 mt-4">
                <vs-checkbox v-model="form.requires_token" class="whitespace-nowrap">
                  Ideal for Pay & Collect type services
                </vs-checkbox>
              </div>
              <div class="vx-col mb-2 mt-2">
                <vs-checkbox v-model="form.requires_booking_date" @input="onRequiresBookingDateChange">
                  Require date on mobile booking
                </vs-checkbox>
              </div>
              <div class="vx-col mb-2 mt-2">
                <vs-checkbox v-model="form.requires_time_slot" :disabled="!form.requires_booking_date">
                  Require time slot on mobile booking
                </vs-checkbox>
              </div>
            </div>

          </div>

          <!-- Save & Reset Button -->
          <div class="vx-row pt-5 px-5 text-center">
            <div class="vx-col w-full">
              <div class="items-center">
                <vs-button class="mr-2 vs-con-loading__container" id="create-creator" @click="save_changes"> {{
                  $route.params.id ? 'Update' : 'Add' }}</vs-button>
                <vs-button color="danger" class="text-left" @click="navigateList">Cancel</vs-button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </vs-card>
</template>

<script>
import Select2 from '@/components/custom/form-elements/Select2.vue'
import PercentageInput from '@/components/custom/PercentageInput.vue'
import { clampPlatformFeePercent, getPlatformFeeError } from '@/utils/platformFee'
import { mapActions, mapState } from 'vuex'

export default {
  /** Page Name */
  name: 'AddUpdate',

  /** components */
  components: {
    Select2,
    PercentageInput
  },

  /** data */
  data() {
    return {
      fileKey: 0,
      CreatorTypes: [],
      breadcrumb: [],
      form: {
        service_name: null,
        service_image: null,
        service_type: "Gurudwara",
        requires_token: false,
        requires_booking_date: true,
        requires_time_slot: true,
        collection_platform_fee: 0,
      },
      preview_image: null
    }
  },

  /** computed */
  computed: {
    ...mapState('gurudwaraServices', ['createLoading']),
    validateForm() {
      return !this.errors.any()
    },
    imagevalidationRule() {
      return !this.$route.params.id ? 'required' : ''
    }
  },

  /** created */
  async created() {
    if (this.$route.params.id) {
      await this.$store.dispatch('gurudwaraServices/show', this.$route.params.id).then(async (res) => {
        const data = res.data.data.service
        console.log(data, 'data');


        /** breadcrumb implement  */
        this.breadcrumb = [
          { title: 'Dashboard', url: '/dashboard' },
          { title: 'Services', url: '/services/list' },
          { title: `Edit ${data.service_name}`, active: true }
        ]

        /* form variable */
        this.form.service_name = data.service_name
        this.preview_image = data.service_image ? data.service_image : null
        this.form.requires_token = data.requires_token || false
        this.form.requires_booking_date = data.requires_booking_date !== false
        this.form.requires_time_slot = data.requires_time_slot !== false
        if (!this.form.requires_booking_date) {
          this.form.requires_time_slot = false
        }
        this.form.collection_platform_fee = clampPlatformFeePercent(data.collection_platform_fee || 0)
      })
    }
  },

  /** methods */
  methods: {
    ...mapActions('gurudwaraServices', {
      create: 'create',
      update: 'update'
    }),
    onRequiresBookingDateChange(value) {
      if (!value) {
        this.form.requires_time_slot = false
      }
    },
    handlePlatformFeeInput() {
      const raw = this.form.collection_platform_fee
      if (raw === '' || raw === null || raw === undefined) return
      const clamped = clampPlatformFeePercent(raw)
      if (clamped !== Number(raw)) {
        this.form.collection_platform_fee = clamped
      }
    },
    async save_changes() {
      const feeError = getPlatformFeeError(this.form.collection_platform_fee)
      if (feeError) {
        this.$vs.notify({
          title: 'Error',
          text: feeError,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'primary'
        })
        return false
      }
      this.form.collection_platform_fee = clampPlatformFeePercent(this.form.collection_platform_fee)
      if (!(await this.$validator.validate())) {
        this.$vs.notify({
          title: 'Error',
          text: 'Please fix the error first',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'primary'
        })
        return false
      }
      if (!this.$route.params.id && !this.form.service_image) {
        this.$vs.notify({
          title: 'Error',
          text: 'Image Is Required!',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'primary'
        })
        return false
      }
      try {
        let response
        const data = new FormData()
        for (const key in this.form) {
          if (this.form[key] !== null && this.form[key] !== undefined) {
            if (typeof this.form[key] === 'object' && key != 'service_image') {
              this.form[key].map((item) => {
                data.append(`${key  }[]`, item)
              })
            } else {
              data.append(key, this.form[key])
            }
          }
        }
        if (this.$route.params.id) {
          response = await this.update({
            id: this.$route.params.id,
            data
          })
        } else {
          response = await this.create(data)
        }
        this.$router.push({
          name: 'services-list'
        })
        this.$emit('update-data', true)
        this.$vs.notify({
          title: 'Success',
          text: response.message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'success'
        })
      } catch ({ message }) {
        this.$vs.notify({
          title: 'Error',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'primary'
        })
      }
    },

    /** navigate to list */
    navigateList() {
      this.$vs.dialog({
        type: 'confirm',
        color: 'primary',
        title: `Confirm Cancel`,
        text: `Are you sure you want to cancel?`,
        accept: () => {
          this.$router.push({ name: 'services-list' })
        },
        acceptText: 'Yes',
        cancelText: 'No'
      })
    },

    /** file upload  */
    handleFileUpload(e) {
      const file = e.target.files[0]

      // Check if a file is selected
      if (!file) {
        this.$vs.notify({
          title: 'Error',
          text: 'No file selected',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'primary'
        })
        return
      }

      // Restrict file types
      const allowedTypes = ['image/jpeg', 'image/png', 'image/jpg']
      if (!allowedTypes.includes(file.type)) {
        this.$vs.notify({
          title: 'Error',
          text: 'Only JPG, PNG, and JPEG images are allowed.',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'primary'
        })
        return
      }

      // Set the file directly to form.image
      this.form.service_image = file

      // Create preview
      this.preview_image = URL.createObjectURL(file)
    }
  },

  /** watch */
  watch: {
    breadcrumb(newvalue) {
      this.$emit('update-breadcrumb', newvalue)
    },
    createLoading() {
      if (this.createLoading) {
        this.$vs.loading({
          container: '#create-creator',
          scale: 0.45
        })
      } else {
        this.$vs.loading.close('#create-creator > .con-vs-loading')
      }
    }
  }
}
</script>